<script setup lang="ts">
const { isDesktop } = useResponsive();
</script>

<template>
  <header id="site-header" class="isolate flex flex-col">
    <SiteHeaderBanner class="order-last lg:order-none" />
    <SiteHeaderDesktop v-if="isDesktop" class="mt-4" />
    <SiteHeaderMobile v-else />
    <div class="container my-4 flex items-start justify-between gap-4 lg:my-8">
      <SiteLogo class="mx-auto lg:mx-0 lg:mt-6" />
      <SiteHeaderSearch v-if="isDesktop" class="z-header w-1/2" />
    </div>
    <SiteMenuDesktop v-if="isDesktop" />
  </header>
</template>
